import { StyleSheet } from '../web';

export const flex = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
    column: {
        flexDirection: 'column',
    },
    alignItemsCenter: {
        alignItems: 'center',
    },
    alignItemsStart: {
        alignItems: 'flex-start',
    },
    alignItemsEnd: {
        alignItems: 'flex-end',
    },
    alignItemsStretch: {
        alignItems: 'stretch',
    },
    alignSelfCenter: {
        alignSelf: 'center',
    },
    alignSelfBaseline: {
        alignSelf: 'baseline',
    },
    alignSelfEnd: {
        alignSelf: 'flex-end',
    },
    justifyCenter: {
        justifyContent: 'center',
    },
    justifyStart: {
        justifyContent: 'flex-start',
    },
    justifyEnd: {
        justifyContent: 'flex-end',
    },
    justifySpaceBetween: {
        justifyContent: 'space-between',
    },
    justifySpaceAround: {
        justifyContent: 'space-around',
    },
    flex1: {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: '0%',
    },
    flex2: {
        flex: 2,
    },
    flex0Auto: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'auto',
    },
    shrink1: {
        flexShrink: 1,
    },
    grow1: {
        flexGrow: 1,
    },
    wrap: {
        flexWrap: 'wrap',
    },
    flexBasisAuto: {
        flexBasis: 'auto',
    },
    unset: {
        // @ts-ignore
        flex: 'unset',
    },
});
